import Editor from '@monaco-editor/react'
import {Box} from '@mui/material'
import githubDarkTheme from "@/themes/github-dark.json";

interface RatingOutputViewerProps {
    content: string
}

function RatingOutputViewer({content}: RatingOutputViewerProps) {
    return (
        <Box sx={{
            height: 'calc(100vh - 150px)',
            border: '1px solid #e0e0e0',
            borderRadius: '4px',
            display: 'flex',
            flexDirection: 'column',
            marginRight: '30px',
        }}>
            <div style={{flex: 1, minHeight: 0}}>
                <Editor
                    height="100%"
                    language="json"
                    theme="github-dark"
                    defaultLanguage="json"
                    value={content}
                    options={{
                        readOnly: true,
                        minimap: {enabled: false},
                        scrollBeyondLastLine: false,
                        fontSize: 12,
                        fontWeight: '500',
                        wordWrap: 'off',
                        automaticLayout: true,
                        folding: true,
                        foldingStrategy: 'auto',
                        showFoldingControls: 'always',
                        glyphMargin: true,
                        lineNumbers: 'on',
                        renderLineHighlight: 'all',
                        lineDecorationsWidth: 10,
                        lineNumbersMinChars: 3,
                        unicodeHighlight: {
                            ambiguousCharacters: false,
                            invisibleCharacters: false
                        }
                    }}
                    beforeMount={(monaco) => {
                        monaco.editor.defineTheme('github-dark', githubDarkTheme as any)
                        monaco.editor.EditorOptions.fontSize.defaultValue = 12
                    }}
                    loading={<div>Loading editor...</div>}
                />
            </div>
        </Box>
    )
}

export default RatingOutputViewer
